import jQuery from 'jquery';

export default (window.jQuery = jQuery);
